// import LayoutNews from "@/layouts/LayoutNews";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/zhengwu",
  name: "zhengwu",
  meta: {
    title: "信息公开",
    keepAlive: true,
    icon: require('@/assets/images/icons/gongkai.png')
  },
  // component: () => import("@/views/zhengwu/index.vue"),
  component: () => import("@/views/zhengwu/xinxigongkai.vue"),
  // component: LayoutNews,
  // redirect: "/zhengwu/gongshigonggao",
  children: [
    // {
    //   path: "gongshigonggao",
    //   name: "gongshigonggao",
    //   meta: {
    //     title: "公示公告",
    // icon: require('@/assets/images/icons/gongkai.png')
    //   },
    //   component: () => import("@/views/zhengwu/components/gongshigonggao.vue"),
    // },
    // {
    //   path: "zhengcewenjian",
    //   name: "zhengcewenjian",
    //   meta: {
    //     title: "政策文件",
    // icon: require('@/assets/images/icons/gongkai.png')
    //   },
    //   component: () => import("@/views/zhengwu/components/zhengcewenjian.vue"),
    // },
    // {
    //   path: "zhengcejiedu",
    //   name: "zhengcejiedu",
    //   meta: {
    //     title: "政策解读",
    // icon: require('@/assets/images/icons/gongkai.png')
    //   },
    //   component: () => import("@/views/zhengwu/components/zhengcejiedu.vue"),
    // },
  ],
},
{
  path: "/zhengwu-detail",
  name: "zhengwu-detail",
  meta: {
    title: "信息公开",
    hidden: true,
    icon: require('@/assets/images/icons/gongkai.png')
  },
  component: LayoutArticle,
  redirect: "/zhengwu/detail",
  children: [{
    path: "/zhengwu/detail",
    name: "zhengwu_detail",
    meta: {
      title: "文章详情",
      hidden: true,
    },
    component: () => import("@/views/zhengwu/detail.vue"),
  },],
},
]